import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import TestiMonialData from './property-data.json';
import Icon from '@mdi/react';
import { mdiFormatQuoteClose, mdiStar } from '@mdi/js';
import '../../App.css';

export default function Testimonial() {
  const [TestiMonialDataList] = useState(TestiMonialData);

  const titleVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };
const titleRef = useRef(null);
  useEffect(() => {
    const titleEl = titleRef.current; // Cache ref
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-lines");
          } else {
            entry.target.classList.remove("animate-lines");
          }
        });
      },
      { threshold: 0.3 }
    );

    if (titleEl) observer.observe(titleEl);

    return () => {
      if (titleEl) observer.unobserve(titleEl); // Use cached ref
    };
  }, []);

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  const quoteIconVariants = {
    hidden: { scale: 0, rotate: -180 },
    visible: {
      scale: 1,
      rotate: 0,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 20,
        delay: 0.5,
      },
    },
  };

  const starVariants = {
    hidden: { opacity: 0, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.3,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="section" id="Promotors">
      <Container>
         <Row>
            <Col md={12}>
              {/* Section Title */}
              <motion.div 
                className="section-title-box"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={titleVariants}
              >
                <h1 className="section-title" ref={titleRef}>
                  Our <span className="text-primary">Promotors</span>
                  <div className="title-line before-line" />
                  <div className="title-line after-line" />
                </h1>
              </motion.div>
            </Col>
          </Row>

          <Row className="g-4 justify-content-center">
        {TestiMonialDataList.clientsListData.map((data, i) => (
            <Col
            md={6}
            lg={4}
            key={i}
            className="d-flex justify-content-center"
          >
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={cardVariants}
                custom={i}
              >
                <Card className="card-hover card-hover-animated testi-slider-card h-100">
                  <Card.Body>
                    <motion.img
                      src={require(`../../images/user-img/${data.clientImg}`)}
                      alt=""
                      className="testi-user-img avatar-img-lg rounded-circle img-shadow"
                      whileHover={{ scale: 1.1 }}
                      transition={{ duration: 0.3 }}
                    />
                    <motion.div
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      variants={quoteIconVariants}
                    >
                      <Icon path={mdiFormatQuoteClose} className="testi-quote-icon text-primary" />
                    </motion.div>
                    {/* <motion.p
                      className="text-white opacity-85 fst-italic mt-3 pb-1"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.2 }}
                    >
                      "{data.clientReview}"
                    </motion.p> */}
                    <hr className="my-4" />
                    <div className="pt-1 d-flex align-items-center justify-content-between">
                      <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3 }}
                      >
                        <h5 className="mb-1 fs-16">{data.clientName}</h5>
                        <p className="text-white opacity-75 fs-15 mb-0">{data.clientInfo}</p>
                      </motion.div>
                      <motion.div
                        className="d-flex text-warning"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={{
                          visible: {
                            transition: {
                              staggerChildren: 0.1,
                            },
                          },
                        }}
                      >
                        {[...Array(5)].map((_, index) => (
                          <motion.div
                            key={index}
                            variants={starVariants}
                            whileHover={{ scale: 1.2, rotate: 15 }}
                          >
                            <Icon path={mdiStar} className="icon-size-18 me-1" />
                          </motion.div>
                        ))}
                      </motion.div>
                    </div>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
